import forEach from 'lodash/forEach';
import debounce from 'lodash/debounce';
/* eslint-disable */
const SLIDE_DELAY = 400;
const BACKGROUNDS_DELAY = 400;

class HomepageController {

  init() {
    this.screenWidth = window.innerWidth;
    this.currentSlide = 1;
    this.slides = [];
    this.slideTimeoutId = null;
    this.resizeTid = null;
    this.aboutActive = false;
    this.disableMovement = false;
    this.offsetFromMiddle = 0;

    this.initDOMElements();
    this.initBindings();
    this.initGallery();
    this.calculateValues();

    window.setTimeout(() => {
      this.initBackgrounds();
      this.initSlider();
    }, 500);
  }

  initDOMElements() {
    this.page = document.body.querySelector('[data-page]');
    this.gallery = document.body.querySelector('[data-gallery]');
    this.galleryIndicator = this.gallery.querySelector('[data-gallery-indicator]');
    this.galleryTitle = document.body.querySelector('[data-gallery-title]');
    this.themes = document.body.querySelector('[data-themes]');
    this.backgrounds = document.body.querySelector('[data-backgrounds]');
    this.aboutLink = document.body.querySelector('[data-about]');
    this.backLink = document.body.querySelector('[data-back]');
    this.maskLeft = document.body.querySelector('[data-mask-left]');
    this.maskRight = document.body.querySelector('[data-mask-right]');
    this.bodyCopy = document.body.querySelector('[data-body-copy]');
  }

  initBindings() {
    window.addEventListener('resize', debounce(() => {
      this.backgrounds.classList.remove('slide-anim');
      this.backgrounds.classList.remove('slide-in');
      this.backgrounds.classList.add('resize');
      this.backgrounds.classList.add('slide-in');
      window.clearTimeout(this.resizeTid2);
      this.resizeTid2 = window.setTimeout(() => {
        this.backgrounds.classList.remove('slide-in');
        this.backgrounds.classList.remove('resize');
        this.backgrounds.classList.add('slide-anim');
      }, 100);
    }, 50));

    window.addEventListener('resize', () => {
      if (this.aboutActive) {
        window.clearTimeout(this.resizeTid);
        this.resizeTid = window.setTimeout(() => {
          if (this.screenWidth > 1024) {
            this.gallery.classList.add('pre-transition');
            this.maskLeft.classList.add('pre-transition');
            this.maskRight.classList.add('pre-transition');
            this.bodyCopy.classList.add('pre-transition');
            this.moveMask();
            window.setTimeout(() => {
              this.gallery.classList.remove('pre-transition');
              this.maskLeft.classList.remove('pre-transition');
              this.maskRight.classList.remove('pre-transition');
              this.bodyCopy.classList.remove('pre-transition');
              this.disableMovement = false;
            }, 300);
          }
        }, 200);
        this.screenWidth = window.innerWidth;
        this.disableMovement = true;
        this.resetValues();
        this.calculateValues();
      }
    }, false);

    window.addEventListener('mousemove', (e) => {
      if (this.screenWidth > 1024) {
        this.offsetFromMiddle = (this.screenWidth / 2) - event.pageX;
        if (this.aboutActive && this.disableMovement === false) {
          this.moveMask();
        }
      }
    }, false);

    this.aboutLink.addEventListener('click', (e) => {
      e.preventDefault();
      window.clearTimeout(this.slideTimeoutId);
      this.page.classList.add('index--about-active');
      window.setTimeout(() => {
        this.calculateValues();
        this.gallery.classList.add('pre-transition');
        this.maskLeft.classList.add('pre-transition');
        this.maskRight.classList.add('pre-transition');
        this.bodyCopy.classList.add('pre-transition');
        this.moveMask();
        window.setTimeout(() => {
          this.gallery.classList.remove('pre-transition');
          this.maskLeft.classList.remove('pre-transition');
          this.maskRight.classList.remove('pre-transition');
          this.bodyCopy.classList.remove('pre-transition');
          this.aboutActive = true;
        }, 300);
      }, 600);
    }, false);

    this.backLink.addEventListener('click', (e) => {
      let i = 0;
      e.preventDefault();

      this.backgrounds.classList.remove('slide-in');
      this.backgrounds.classList.remove('slide-anim');
      this.page.classList.remove('index--about-active');
      this.resetValues(true);
      this.aboutActive = false;

      window.setTimeout(() => {
        for (i = 1; i <= this.slides.length; i++) {
          this.themes.classList.remove(`background-stripes--theme-${i}`);
        }
        this.themes.classList.add(`background-stripes--theme-${this.currentSlide}`);
        this.backgrounds.classList.add('slide-in');
        window.setTimeout(() => {
          this.backgrounds.classList.add('slide-anim');
        }, BACKGROUNDS_DELAY);
      }, SLIDE_DELAY);

      this.slideTimeoutId = window.setTimeout(() => {
        this.nextSlide();
      }, this.slides[this.currentSlide - 1].delay);
    }, false);
  }

  initGallery() {
    forEach(this.galleryIndicator.querySelectorAll('.item'), (val, key) => {
      if (key === 0) {
        val.classList.add('active');
      }
    });
  }

  initBackgrounds() {
    this.backgrounds.classList.add('slide-in');
    window.setTimeout(() => {
      this.backgrounds.classList.remove('slide-in');
      this.backgrounds.classList.add('slide-anim');
    }, BACKGROUNDS_DELAY);
  }

  initSlider() {
    /* eslint-disable no-param-reassign */
    forEach(this.gallery.querySelectorAll('[data-slide]'), (val) => {
      const slide = {
        title: val.getAttribute('data-title'),
        delay: parseInt(val.getAttribute('data-slide-timeout'), 10),
      };
      this.slides.push(slide);
    });
    /* eslint-enable no-param-reassign */
    this.slideTimeoutId = window.setTimeout(() => {
      this.nextSlide();
    }, this.slides[0].delay);
  }

  nextSlide() {
    let i = 1;

    this.currentSlide++;

    if (this.currentSlide > this.slides.length) {
      this.currentSlide = 1;
    }

    this.backgrounds.classList.remove('slide-in');
    this.backgrounds.classList.remove('slide-anim');

    window.setTimeout(() => {
      for (i = 1; i <= this.slides.length; i++) {
        this.themes.classList.remove(`background-stripes--theme-${i}`);
      }

      this.themes.classList.add(`background-stripes--theme-${this.currentSlide}`);
      this.backgrounds.classList.add('slide-in');

      window.setTimeout(() => {
        this.backgrounds.classList.add('slide-anim');
      }, SLIDE_DELAY);

      this.updateGallery();
    }, BACKGROUNDS_DELAY);

    window.clearTimeout(this.slideTimeoutId);
    this.slideTimeoutId = window.setTimeout(() => {
      this.nextSlide();
    }, this.slides[this.currentSlide - 1].delay - BACKGROUNDS_DELAY);
  }

  updateGallery() {
    let i = 1;
    for (i; i <= this.slides.length; i++) {
      this.gallery.classList.remove(`gallery--slide-to-${i}`);
    }

    this.gallery.classList.add(`gallery--slide-to-${this.currentSlide}`);
    this.galleryTitle.innerHTML = this.slides[this.currentSlide - 1].title;

    forEach(this.galleryIndicator.querySelectorAll('.item'), (val, key) => {
      val.classList.remove('active');
      if (key === this.currentSlide - 1) {
        val.classList.add('active');
      }
    });
  }

  calculateValues() {
    const galleryStyle = window.getComputedStyle(this.gallery);
    const maskLeftStyle = window.getComputedStyle(this.maskLeft);
    const maskRightStyle = window.getComputedStyle(this.maskRight);
    const bodyCopyStyle = window.getComputedStyle(this.bodyCopy);
    const ratio = this.offsetFromMiddle / 5;

    this.gallery.classList.add('no-transition');
    this.maskLeft.classList.add('no-transition');
    this.maskRight.classList.add('no-transition');
    this.bodyCopy.classList.add('no-transition');

    this.galleryOriginalLeft = parseInt(galleryStyle.getPropertyValue('left'), 10) + ratio;
    this.galleryOriginalRight = parseInt(galleryStyle.getPropertyValue('right'), 10) - ratio;
    this.maskLeftOriginal = parseInt(maskLeftStyle.getPropertyValue('width'), 10) + ratio;
    this.maskRightOriginal = parseInt(maskRightStyle.getPropertyValue('width'), 10) - ratio;
    this.bodyCopyOriginal = parseInt(bodyCopyStyle.getPropertyValue('width'), 10) + ratio;
  }

  resetValues(justValue = false) {
    this.gallery.removeAttribute('style');
    this.maskLeft.removeAttribute('style');
    this.maskRight.removeAttribute('style');
    this.bodyCopy.removeAttribute('style');

    if (justValue !== false) {
      this.gallery.classList.remove('no-transition');
      this.maskLeft.classList.remove('no-transition');
      this.maskRight.classList.remove('no-transition');
      this.bodyCopy.classList.remove('no-transition');
    }

    forEach(this.gallery.querySelectorAll('[data-slide]'), (item) => {
      item.style.backgroundPosition = `50% 50%`;
    });
  }

  moveMask() {
    const ratio = this.offsetFromMiddle / 5;

    this.gallery.style.left = `${this.galleryOriginalLeft + ratio}px`;
    this.gallery.style.right = `${this.galleryOriginalRight - ratio}px`;
    this.maskLeft.style.width = `${this.maskLeftOriginal + ratio}px`;
    this.maskRight.style.width = `${this.maskRightOriginal - ratio}px`;
    this.bodyCopy.style.width = `${this.bodyCopyOriginal + ratio}px`;

    forEach(this.gallery.querySelectorAll('[data-slide]'), (item, key) => {
      if (key === this.currentSlide - 1) {
        item.style.backgroundPosition = `calc(50% + ${ratio * 1.7}px) 50%`;
      }
    });

  }
}

export const homepageController = new HomepageController();



// WEBPACK FOOTER //
// ./src/js/modules/homepage-controller.js